// Helper function to check if specific features exist in the plan and create a validation state object
export const getPlanValidation = (subscriptionData) => {
    // Initialize validation object with default values (false)
    const planValidation = {
      exchangeContact: false,
      addToWallet: false,
      whatsappExchangeContact: false
    };
  
    // Get feature IDs from environment variables (default to empty strings if undefined)
    const FEATURE_IDS = {
      EXCHANGE_CONTACT: process.env.REACT_APP_EXCHANGE_CONTACT || "",
      ADD_TO_APPLEWALLET_GOOGLEWALLET: process.env.REACT_APP_ADD_TO_APPLEWALLET_GOOGLEWALLET || "",
      WHATSAPP_EXCHANGE_CONTACT: process.env.REACT_APP_WHATSAPP_EXCHANGE_CONTACT || ""
    };

    console.log(FEATURE_IDS, 'FEATURE_IDS');
    
  
    // If no subscription data or no PlanID or features, return default validation object
    if (!subscriptionData || !subscriptionData.PlanID || !subscriptionData.PlanID.features) {
      return planValidation;
    }
  
    // Extract features array
    const features = subscriptionData.PlanID.features;
  
    // Check each feature and update validation object
    features.forEach(feature => {
      const { featureID, value } = feature;
      
      // Check for exchange contact feature
      if (FEATURE_IDS.EXCHANGE_CONTACT && featureID === FEATURE_IDS.EXCHANGE_CONTACT) {
        planValidation.exchangeContact = Boolean(value);
      }
      
      // Check for add to wallet feature
      if (FEATURE_IDS.ADD_TO_APPLEWALLET_GOOGLEWALLET && featureID === FEATURE_IDS.ADD_TO_APPLEWALLET_GOOGLEWALLET) {
        planValidation.addToWallet = Boolean(value);
      }
      
      // Check for WhatsApp exchange contact feature
      if (FEATURE_IDS.WHATSAPP_EXCHANGE_CONTACT && featureID === FEATURE_IDS.WHATSAPP_EXCHANGE_CONTACT) {
        planValidation.whatsappExchangeContact = value !== false && value !== "0";
      }
    });
  
    return planValidation;
  };